import React from 'react';

import { Glossary, BoardGL } from 'common/utils/glossary';
import { Button, Title, Popup, Spinner } from 'common/components';
import { SubButtonType } from 'common/components/button';

interface CancellationConfirmationDialogProps {
  /** CancellationConfirmationDialogの表示有無 */
  isDisplay: boolean;
  /** グロッサリ */
  glossary: Glossary;
  /** 第三者利用権返却中か否か */
  isProcessing: boolean;
  /** "OKボタン"の押下処理 */
  onClickOk: () => void;
  /** "キャンセルボタン"の押下処理 */
  onClickCancel: () => void;
}

/**
 * 利用解除確認ダイアログ画面のPresentation Component
 */
export const CancellationConfirmationDialog: React.FC<CancellationConfirmationDialogProps> = ({
  isDisplay,
  glossary,
  isProcessing,
  onClickOk,
  onClickCancel
}) => {
  const onClickDeleteProcessing = () => {
    // 第三者利用権返却処理中はバックグラウンドをクリックしても何もしない
  };

  // OKボタンのSubButtonTypeを設定
  const subButtonType: SubButtonType = isProcessing
    ? 'invalid'
    : 'highPriority';
  // 確認ダイアログ表示
  const dialogMessage = (
    <Title type="title" data-test="cancellationConfirmationDialog-title">
      {glossary.glx(BoardGL.CancellationConfirmationTitle)}
    </Title>
  );
  const buttonComponent = (
    <div
      className="cancellationConfirmationDialogButton"
      data-test="cancellationConfirmationDialogButton"
    >
      <Button
        type="okButton"
        subType={subButtonType}
        data-test="cancellationConfirmationDialog-okButton"
        onClick={isProcessing ? onClickDeleteProcessing : onClickOk}
      >
        {isProcessing ? (
          <Spinner type="button" width={22} height={22} color="#FFFFFF" />
        ) : (
          glossary.glx(BoardGL.CancellationConfirmationOK)
        )}
      </Button>
      <Button
        type="cancelButton"
        data-test="cancellationConfirmationDialog-cancelButton"
        onClick={onClickCancel}
      >
        {glossary.glx(BoardGL.CancellationConfirmationCancel)}
      </Button>
    </div>
  );

  const _component = (
    <Popup
      className="cancellationConfirmation-popup"
      onClickBackground={isProcessing ? onClickDeleteProcessing : onClickCancel}
      data-test="cancellationConfirmation-popup"
      visible={isDisplay}
    >
      <div
        className="cancellationConfirmationDialog"
        data-test="cancellationConfirmationDialog"
      >
        {dialogMessage}
        {buttonComponent}
      </div>
    </Popup>
  );
  return isDisplay ? _component : null;
};
